<template>
	<v-container>
		<v-container pa-2>
			<div :class="['text-h6', 'd-flex', 'justify-center']">{{ $t('titles.appointment') }}</div>
		</v-container>
		<v-row>
			<v-col cols="12">
				<v-col cols="12">
					<Dropdown
						v-model="appointment.appointment_location_id"
						:ajax="true"
						:data="'appointment-locations'"
						:label="'* ' + $t('fields.appointmentLocation')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<DatePicker
						v-model="appointment.date"
						:errorBorder="!appointmentValidation.date"
						:date-label="'* ' + $t('fields.date')"
					></DatePicker>
				</v-col>
				<v-col cols="12">
					<Dropdown
						v-model="appointment.teacher_id"
						:ajax="true"
						:data="'teachers'"
						:errorBorder="!appointmentValidation.teacher_id"
						:label="'* ' + $t('fields.teacher')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<Dropdown
						v-model="appointment.course_module_id"
						:ajax="true"
						:data="'course-modules/' + courseId"
						:errorBorder="!appointmentValidation.course_module_id"
						:label="'* ' + $t('fields.module')"
					></Dropdown>
				</v-col>
				<v-col cols="12">
					<TimePicker2
						v-model="appointment.start_time"
						:placeholder="'hh:mm'"
						:errorBorder="!appointmentValidation.start_time"
						:label="'* ' + $t('fields.startAppointmentTime')"
					></TimePicker2>
				</v-col>
				<v-col cols="12">
					<TimePicker2
						v-model="appointment.end_time"
						placeholder="hh:mm"
						:errorBorder="!appointmentValidation.end_time"
						:label="'* ' + $t('fields.endAppointmentTime')"
					></TimePicker2>
				</v-col>
			</v-col>
		</v-row>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12" class="d-flex justify-center">
				<v-btn class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Dropdown from '../../trinkets/Dropdown';
import TimePicker2 from '../../trinkets/TimePicker2';
import DatePicker from '../../trinkets/DatePicker';
import Appointment from '../../../models/Appointment';

export default {
	name: 'AppointmentForm',
	components: { Dropdown, DatePicker, TimePicker2 },
	props: {
		appointmentId: [String, Number],
		plannedCourseId: [String, Number],
		appointmentLocationId: [String, Number],
		courseId: [String, Number],
	},
	emits: ['close', 'reloadCalendar', 'reloadSchedule', 'reloadTeachersOnCourse'],
	watch: {},
	data() {
		return {
			appointment: new Appointment({
				id: this.appointmentId,
				appointment_location_id: this.appointmentLocationId,
				planned_course_id: this.plannedCourseId,
			}),
			appointmentValidation: new Appointment({}, true),
			inEditMode: false,
		};
	},
	methods: {
		cancelClick() {
			this.$emit('close');
		},
		getAppointment() {
			let vm = this;
			this.$APICall('get', 'appointments/' + this.appointmentId, {}, (data, succes) => {
				if (succes) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.appointment = usableData;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		validateTime(start_time, end_time) {
			let validationResult = '';
			if (start_time.length != null && end_time.length != null) {
				if (start_time.length != 5 || end_time.length != 5) {
					validationResult = this.$t('alerts.appointmentTimeFormat');
				} else {
					let startTimeHours = parseInt(start_time.substring(0, 2));
					let startTimeMins = parseInt(start_time.substring(3, 5));
					let endTimeHours = parseInt(end_time.substring(0, 2));
					let endTimeMins = parseInt(end_time.substring(3, 5));
					if (
						(startTimeMins != 15 && startTimeMins != 30 && startTimeMins != 45 && startTimeMins != 0) ||
						(endTimeMins != 15 && endTimeMins != 30 && endTimeMins != 45 && endTimeMins != 0)
					) {
						validationResult += this.$t('alerts.appointmentTimeFormat4') + '<br />';
					}
					if (startTimeHours > 23 || startTimeMins > 59 || endTimeHours > 23 || endTimeMins > 59) {
						validationResult = this.$t('alerts.appointmentTimeFormat2');
					} else {
						let timeFromDate = new Date();
						let timeToDate = new Date();
						timeFromDate.setHours(startTimeHours);
						timeFromDate.setMinutes(startTimeMins);
						timeToDate.setHours(endTimeHours);
						timeToDate.setMinutes(endTimeMins);
						if (timeFromDate > timeToDate) {
							validationResult = this.$t('alerts.appointmentTimeFormat3');
						}
					}
				}
			}
			return validationResult;
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			if (!this.appointment.appointment_location_id) {
				success = false;
				this.appointmentValidation.appointment_location_id = false;
			} else {
				this.appointmentValidation.appointment_location_id = true;
			}

			if (!this.appointment.teacher_id) {
				success = false;
				this.appointmentValidation.teacher_id = false;
			} else {
				this.appointmentValidation.teacher_id = true;
			}

			if (!this.appointment.course_module_id) {
				success = false;
				this.appointmentValidation.course_module_id = false;
			} else {
				this.appointmentValidation.course_module_id = true;
			}

			if (!this.appointment.date) {
				success = false;
				this.appointmentValidation.date = false;
			} else {
				this.appointmentValidation.date = true;
			}

			if (!this.appointment.start_time) {
				success = false;
				this.appointmentValidation.start_time = false;
			} else {
				this.appointmentValidation.start_time = true;
			}

			if (!this.appointment.end_time) {
				success = false;
				this.appointmentValidation.end_time = false;
			} else {
				this.appointmentValidation.end_time = true;
			}

			if (this.appointment.end_time != null && this.appointment.start_time != null) {
				errorMessages = this.validateTime(this.appointment.start_time, this.appointment.end_time);
				if (errorMessages != '') {
					success = false;
				}
			} else {
				this.appointmentValidation.start_time = null;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.appointment.id != 0) {
					action = 'put';
					addition = '/' + vm.appointment.id;
				} else {
					this.appointment.planned_course_id = this.plannedCourseId;
				}
				this.$APICall(action, 'appointments' + addition, this.appointment, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.appointment.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$modalBus.$emit('reloadCalendar', vm.appointmentLocationId);
						vm.$modalBus.$emit('reloadSchedule');
						vm.$modalBus.$emit('reloadTeachersOnCourse');
						vm.$modalBus.$emit('reloadPlannedCourse');
					} else {
						if (Object.hasOwn(data, 'custom')) {
							vm.$alert(data.message);
							this.$emit('close');
							this.$router.go(-1);
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
					this.$emit('close');
				});
			}
		},
	},
	mounted() {
		if (this.appointmentId !== 0) {
			this.getAppointment();
		}
	},
};
</script>

<style scoped>
.appointment-time-input {
	display: inline-block;
	max-width: 50px !important;
}
.appointment-time-input div {
	margin-top: 0px !important;
	padding-top: 0px !important;
}
.appointment-time-separator {
	display: inline-block;
	margin-inline: 20px;
}
.appointment-time-title {
	color: rgb(122, 122, 122);
	font-size: 16px;
}
</style>
